import { defineStore } from "pinia";
import { vehicleService } from "@/_services";

export const vehicleStore = defineStore("vehicle", {
  state: () => ({
    vehicles: null,
    vehiclesExport: null,
    activeVehicles: null,
    allActiveVehicles: null,
    vehicle: null,
    vehicleCreated: null,
    vehicleUpdated: null,
    vehicleDeleted: null,
    error: null,
  }),

  actions: {
    getVehicles(pagination, query, sort) {
      this.error = null;
      return vehicleService
        .getVehicles(pagination, query, sort)
        .then((result) => {
          this.vehicles = result;
        })
        .catch((reason) => {
          this.error = reason;
        });
    },
    exportar(pagination, query, sort) {
      this.error = null;
      this.vehiclesExport = null;
      return vehicleService
        .exportar(pagination, query, sort)
        .then((result) => {
          this.vehiclesExport = result;
          return result;
        })
        .catch((reason) => {
          this.error = reason;
          throw reason;
        });
    },
    getVehicleById(vehicle_id) {
      this.error = null;
      this.vehicle = null;
      return vehicleService
        .getVehicleById(vehicle_id)
        .then((result) => {
          this.vehicle = result;
        })
        .catch((reason) => {
          this.error = reason;
        });
    },
    getActiveVehicles(date) {
      this.error = null;
      this.activeVehicles = [];
      return vehicleService
        .getActiveVehicles(date)
        .then((result) => {
          this.activeVehicles = Array.isArray(result) ? result : [];
        })
        .catch((reason) => {
          this.error = reason;
        });
    },
    getAllActiveVehicles() {
      this.error = null;
      this.allActiveVehicles = [];
      return vehicleService
        .getVehicles({ page: 1, limit: 500 }, { active: true })
        .then((result) => {
          this.allActiveVehicles = result?.data || [];
        })
        .catch((reason) => {
          this.error = reason;
        });
    },
    createVehicle(data) {
      this.error = null;
      this.vehicleCreated = null;
      return vehicleService
        .createVehicle(data)
        .then((result) => {
          this.vehicleCreated = result;
        })
        .catch((reason) => {
          this.error = reason;
        });
    },
    updateVehicle(data, vehicle_id) {
      this.error = null;
      this.vehicleUpdated = null;
      return vehicleService
        .updateVehicle(data, vehicle_id)
        .then((result) => {
          this.vehicleUpdated = result;
        })
        .catch((reason) => {
          this.error = reason;
        });
    },
    deleteVehicle(vehicle_ids) {
      this.error = null;
      this.vehicleDeleted = null;
      return vehicleService
        .deleteVehicle(vehicle_ids)
        .then((result) => {
          this.vehicleDeleted = result;
        })
        .catch((reason) => {
          this.error = reason;
        });
    },
  },
});
